export function checkComingFromOAuth(): boolean {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('from-oauth') === 'true';
}
